import React, { Component } from "react";
import { connect } from 'react-redux';
import Swal from 'sweetalert2'
import SVG from "react-inlinesvg";
import { toast } from 'react-toastify';
import { toAbsoluteUrl } from "../../../../../_helpers";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { getInitialRoute, secondsToTime } from '../../../../../../../../../../utils'
import "./studio.css";
import { UPDATE_ACTIVE_SCENE, DELETE_SCENE, sceneReOrder, UPDATE_STATUS } from '../../../../../../../../../../actions/sceneActions'
import SideLayout from '../../../../../../app/pages/SideLayout'
import { customClass } from '../../../../../../../../../../utils'
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "../../../../../../../../../CommonComponents/AssetsHelper";

const grid = 8;
const getItems = count => Array.from({ length: count }, (v, k) => k).map(k => ({
id: `item-${k}`,
    content: `item ${k}`
}));

const getListStyle = isDraggingOver => ({
    background: 'none',//isDraggingOver ? "lightblue" : "lightgrey",
    width: '100%'
});

const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    // padding: grid * 2,

    // change background colour if dragging
    background: isDragging ? "none" : "none",

    // styles we need to apply on draggables
    ...draggableStyle
});

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
    const result = list;//Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
}
class DisplayStudioLeftBar extends Component {
    state = {
        items: [],
        activeScene: null,
    }
    componentDidMount() {
         const { scenes } = this.props;
        this.setState({ items: scenes.scenes, activeScene: scenes.defaultScene })

    }
    onDragEnd = (result) => {
        // dropped outside the list
        const { items } = this.state;
        if (!result.destination) {
            return;
        }
        const itemsNew = reorder(
            items,
            result.source.index,
            result.destination.index
        );
        this.setState({ items: itemsNew }, () => this.onUpdateWhenDrag(result.destination.index))
    }
    onUpdateWhenDrag = (destinationIndex) => {
        this.props.UPDATE_ACTIVE_SCENE(destinationIndex);
        const { items } = this.state;
        let reorderedItems = items.map((i) => i.id)
        this.props.sceneReOrder(reorderedItems)
    }
    componentWillReceiveProps(nextProps) {
        const { scenes, location } = nextProps;
        this.setState({ items: scenes.scenes, activeScene: scenes.defaultScene }, () => this.onUpdateScenePreview())


    }
    onUpdateScenePreview = () => {
        const { scenes, location } = this.props;
        if (location && location.pathname && location.pathname.includes("/studio/preview")) {
            const { items, activeScene } = this.state;
            if (items && items.length > 0 && items[activeScene]) {
                const activeDataPreview = items[activeScene]
                let nextSceneIndex = null;
                const itemLength = parseInt(items.length) - 1
                if (items && itemLength > 0 && itemLength > activeScene) {
                    nextSceneIndex = parseInt(activeScene) + 1;
                }
                else {
                    nextSceneIndex = 0;
                }
                const timeInterval = parseInt(activeDataPreview.totalTime) * 1000;
                if (this.intervalID) {
                    clearInterval(this.intervalID)
                }
                if (activeDataPreview && activeDataPreview.totalTime) {
                    this.intervalID = setInterval(() => this.props.UPDATE_ACTIVE_SCENE(nextSceneIndex), timeInterval)
                }
            }

        }
    }

    onClickToActiveScene = (item, index) => event => {
        this.props.UPDATE_ACTIVE_SCENE(index)
        const { location, history, wallID } = this.props;
        if (location.pathname && location.pathname.includes('add/scene')) {
            history(`${location.pathname.replace('/add/scene', '')}`)
        }
        if (location.pathname && location.pathname.includes('studio/display/')) {
            let pathData = `/studio/${wallID}`;
            history(pathData)
        }

    }


    callbackScene=(sceneID)=>{

       setTimeout(() => {

       const { history, wallID, scenes, studio} =this.props;
       const totalTime =scenes.scenes.filter(obj=> obj['totalTime']>0 && obj['id']!=sceneID && obj['status']==1)
       
       if((totalTime.length==0) && studio.studioWall.is_studio_enabled){
            this.props.UPDATE_STATUS(false,wallID)
        }

        toast.success("Scene deleted successfully", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });

        history(`/studio/${wallID}`)

         }, 1000);
    }

    onDeleteScene = (sceneID) => event => {
        Swal.fire({
            title: "Are you sure?",
            text: "You want to delete scene now?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Delete",
            cancelButtonText: "Back",
            reverseButtons: true,
            customClass: customClass
        }).then((result) => {
            if (result.value) {
                this.props.DELETE_SCENE(sceneID,()=>this.callbackScene(sceneID))
            }
            else if (result.dismiss === "cancel") {

            }
        });

    }
    render() {
        const { items, activeScene } = this.state;
         const isPreview = window.location.toString().includes("preview");
        
        return <DragDropContext onDragEnd={this.onDragEnd} style={{ background: 'none', width: '100%' }}>
            <Droppable droppableId="droppableScenes" style={{ background: 'none', width: '100%' }}>
                {(provided, snapshot) => (
                    <div
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                        style={getListStyle(snapshot.isDraggingOver)}
                    >
                        {items.map((item, index) => {
                            return <Draggable key={`side_${item.id}`} draggableId={`dragg_side${item.id}`} index={index} shouldRespectForcePress={false} >
                                {(provided, snapshot) => (
                                    <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        style={getItemStyle(
                                            snapshot.isDragging,
                                            provided.draggableProps.style
                                        )}
                                    >
                                       
                                        <div className="mb-2">
                                            <div className={`template_view ${(activeScene == index) ? (isPreview && item.status ==`0`) ? `scene-active not-scene-active`: `scene-active` : ``}`} onClick={this.onClickToActiveScene(item, index)} onMouseEnter={this.switchHover}
                                                onMouseLeave={this.switchHover}>
                                                <div className={'template_view_head d-flex align-items-center justify-content-between'}>
                                                    <div className={'template_title template_title text-nowrap overflow-hidden'}>
                                                        {item.name}
                                                        {/* Scene {index + 1} */}
                                                    </div>
                                                    <div className={'template_timer'}>{secondsToTime(item.totalTime)}</div>
                                                </div>
                                                <div className="template_view_card">
                                                    <SideLayout active={item.mixContentType} />
                                                </div>
                                                <Button variant="secondary" className={`template_view_action`} onClick={this.onDeleteScene(item.id)}>
                                                    <FontAwesomeIcon type={'regular'} icon={'trash-can'} iconClass={'fs-6'}/>
                                                    <span className="ms-2">Delete Scene</span>
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </Draggable>
                        })}
                    </div>)}
            </Droppable>
        </DragDropContext>


    }
}
const mapStateToProps = state => {
    return {
        scenes: state.scene,
        studio : state.studio
    }
}
const mapDispatchToProps = dispatch => {
    return {
        UPDATE_ACTIVE_SCENE: (sceneID) => dispatch(UPDATE_ACTIVE_SCENE(sceneID)),
        DELETE_SCENE: (sceneID, callbackScene) => dispatch(DELETE_SCENE(sceneID, callbackScene)),
        UPDATE_STATUS: (status,wallId) => dispatch(UPDATE_STATUS(status,wallId)),
        sceneReOrder: (reorderedItems) => dispatch(sceneReOrder(reorderedItems)),


    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DisplayStudioLeftBar);